import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faEye, faEyeSlash } from '@fortawesome/pro-solid-svg-icons';
import React from 'react';
import { IconButton } from '../..';
import { withFormGroup } from '../../common/FormGroup/FormGroup';
import { TEXT_FIELD_DEFAULT_DISABLED, TEXT_FIELD_DEFAULT_MODE, TEXT_FIELD_DEFAULT_ROLE, TEXT_FIELD_DEFAULT_SIZE, TEXT_FIELD_DEFAULT_TYPE } from './TextField.constants';
import { useTextField } from './TextField.hooks';
import { TextFieldRoot, TextFieldWrapper } from './TextField.styled';
// Component.
// -----------------------------------------------------------------------------
const TextField = withFormGroup(({ disabled = TEXT_FIELD_DEFAULT_DISABLED, mode = TEXT_FIELD_DEFAULT_MODE, name, role = TEXT_FIELD_DEFAULT_ROLE, size = TEXT_FIELD_DEFAULT_SIZE, type = TEXT_FIELD_DEFAULT_TYPE, inputRef, ...rest }) => {
    // Hooks.
    // -------------------------------------------------------------------------
    const { inputType, onClickShowPassword } = useTextField(type);
    // Render.
    // -------------------------------------------------------------------------
    return (_jsxs(TextFieldWrapper, { children: [_jsx(TextFieldRoot, { ...(role && { className: role }), disabled: disabled, id: name, mode: mode, name: name, role: "textbox", 
                // we are using 'scale' because input has its own 'size'.
                scale: size, type: inputType, ref: inputRef, ...rest }), type === 'password' && role !== 'error' && (_jsx(IconButton, { "aria-label": "show password", className: "btn-eye", icon: inputType === 'password' ? faEye : faEyeSlash, mode: mode, onClick: onClickShowPassword, schema: "neutral", variant: "bare" }))] }));
});
// Component configuration.
// -----------------------------------------------------------------------------
TextField.displayName = 'TextField';
const TextFieldWithFormGroup = React.forwardRef((props, ref) => {
    return _jsx(TextField, { ...props, inputRef: ref });
});
TextFieldWithFormGroup.displayName = 'TextFieldWithFormGroup';
export default TextFieldWithFormGroup;
//# sourceMappingURL=TextField.js.map